<template>
  <div>
    <SearchBar ref="SearchBar" :checkList="checkList" />
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      @selection-change="handleSelectionChange"
      fit
      highlight-current-row
      height="750"
    >
      <!--<el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column>-->
      <el-table-column label="账号" align="center" prop="userCode" />
      <el-table-column label="姓名" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.userName) }}
        </template>
      </el-table-column>
      <el-table-column label="操作时间" align="center" prop="createTime">
        <!--<template slot-scope="scope">
          {{ handledecrypt(scope.row.userName) }}
        </template>-->
      </el-table-column>

      <el-table-column label="登录端" align="center" prop="operateModule">
      </el-table-column>

      <el-table-column label="操作模块" align="center" prop="operateModule">
        <template> 登录 </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="操作内容"
        align="center"
        prop="operateContent"
      >
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="操作结果"
        align="center"
        prop="statusTxt"
      >
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="操作"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            size="small"
            @click="toLookAwait(scope.row)"
            v-if="roleList[path].includes('To_be_issued')"
            >查看日志详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination ref="Pagination" />
    <Detail ref="Detail" />
  </div>
</template>

<script>
import { getLoginLog } from '@/api/log.js';
import SearchBar from './components/searchBar'; // 搜索框
import Detail from './components/detail';
import Pagination from '@/components/Pagination'; // 分页
import { mapGetters } from 'vuex';
import { decrypt } from '@/utils/encryp';

export default {
  components: {
    SearchBar,
    Pagination,
    Detail,
  },
  data() {
    return {
      list: null,
      listLoading: false,
      pageSize: 0,
      pageIndex: 0,
      path: '',
      checkList: [],
    };
  },
  mounted() {
    this.fetchData();
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    paginObj: 'fetchData',
  },
  methods: {
    // 处理解密
    handledecrypt(str, isShowAllPhone = true) {
      // if (!str || str.indexOf('=') == -1) return str;
      let showStr = decrypt(str);
      return isShowAllPhone
        ? showStr
        : showStr.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    // 请求表单数据
    async fetchData(obj = {}) {
      try {
        let searchObj = this.$refs.SearchBar.getParams();
        this.listLoading = true;
        const areaId = localStorage.getItem('areaId')
          ? JSON.parse(localStorage.getItem('areaId')).areaId
          : '';
        let res = await getLoginLog({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          areaId,
          ...obj,
          ...searchObj,
        });
        let { pageSize, pageIndex, dataList, totalCount } = res.data;
        this.list = dataList;
        this.pageSize = pageSize;
        this.listLoading = false;
        this.pageIndex = pageIndex;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;

        this.$refs.Pagination.totalCount = Number(totalCount);
      } catch (e) {
        window.console.log(e);
      }
    },

    toLookAwait(row) {
      this.$refs.Detail.form = row;
      this.$refs.Detail.dialogFormVisible = true;
    },

    toLookYet(row) {
      if (row.userBonus === null) {
        return this.$message.error('无此数据！');
      }
      let bonusId = row.userBonus.bonusId;
      this.$router.push(`lookYet?id=${bonusId}`);
    },
    handleSelectionChange(val) {
      this.checkList = val.map((item) => {
        return item.userId;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.btn {
  display: flex;
  align-items: center;
}
/deep/ .el-checkbox__input {
  margin-left: 10px;
}
</style>
